'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HomeLinksController;

require('./home-links.scss');

/*@ngInject*/
function HomeLinksController($scope, $mdMedia, menu) {

    var vm = this;

    vm.sectionColspan = sectionColspan;

    $scope.$watch(function () {
        return $mdMedia('lg');
    }, function () {
        updateColumnCount();
    });

    $scope.$watch(function () {
        return $mdMedia('gt-lg');
    }, function () {
        updateColumnCount();
    });

    updateColumnCount();

    vm.model = menu.getHomeSections();

    function updateColumnCount() {
        vm.cols = 2;
        if ($mdMedia('lg')) {
            vm.cols = 3;
        }
        if ($mdMedia('gt-lg')) {
            vm.cols = 4;
        }
    }

    function sectionColspan(section) {
        var colspan = vm.cols;
        if (section && section.places && section.places.length <= colspan) {
            colspan = section.places.length;
        }
        return colspan;
    }
} /*
   * Copyright © 2016-2018 The Thingsboard Authors
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */


// WEBPACK FOOTER //
// ./src/app/home/home-links.controller.js